<template>
	<!-- 派单管理 -->
	<div class="billOperationRecord public_Spacing">
		<div class="pulbic_oparetionBlock" style="margin-bottom: 12px;">
			<div class="public_criteriaRange">
				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">企业：</label>
					<el-select class="public_optionSty dropDown_Define" @change="erpChange" v-model="enterpriseTwo"
						placeholder="请选择">
						<el-option v-for="item in enterpriseTwoOptionList" :key="item.SETTB99ID"
							:label="item.SETTB99CA00" :value="item.SETTB99ID">
						</el-option>
					</el-select>
				</div> -->
				<div class="public_oparetionBlock_Menu" v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'">
					<label class="public_lbSty">客户：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="customerMo" placeholder="请选择" filterable>
						<el-option v-for="item in customerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
							:value="item.ORMTB410ID">
						</el-option>
					</el-select>
				</div>
				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">物料：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择"
						filterable>
						<el-option v-for="item in materielOptions" :key="item.SETTB109ID" :label="item.SETTB109CA00"
							:value="item.SETTB109ID">
						</el-option>
					</el-select>
				</div> -->
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">状态：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="SETTB122CA07" placeholder="请选择">
						<el-option v-for="item in dataStatusOperation" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">车牌号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" type="text" placeholder="请输入" v-model="carNumber" />
						</div>
					</div>
				</div> -->
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">手机号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="pulic_carNumber" maxlength="11" type="text" placeholder="请输入" v-model="cusQueryiphone" />
						</div>
					</div>
				</div>
				<!-- <div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">时间：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="timeType" placeholder="请选择">
						<el-option label="派单时间" value="1">
						</el-option>
						<el-option label="结算时间" value="2">
						</el-option>
					</el-select>
				</div> -->
			</div>
			<div class="public_operatArea">
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive ? 'public_dateActive' : ''"
					@click="getNowDay">当日</span>
				<span class="public_operatArea_yesterday pulic_cursor" :class="dateYesterdayActive ? 'public_dateActive' : ''"
					@click="getYesterday">昨天</span>
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive ? 'public_dateActive' : ''"
					@click="sameMonth">当月</span>
				<span class="public_operatArea_yesterday pulic_cursor" :class="dateLastMonthActive ? 'public_dateActive' : ''"
					@click="lastMonth">上月</span>
				<div class="public_operatArea_timePicker pulic_cursor">
					<el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
						:picker-options="startDateDisabled" @change="datePickerChange" start-placeholder="开始日" end-placeholder="结束日"
						class="pulic_cursor">
					</el-date-picker>
				</div>
				<div class="public_operatBtn">
					<button @click="queryClick" class="public_saleWater_chaxun pulic_cursor" v-shiroHiden="solelist" id="查询"><i
							class="iconfont icon-chaxun"></i>查询</button>
					<el-button class="public_saleWater_daochu pulic_cursor" :loading="loadingBut" @click="exports"
						v-shiroHiden="solelist" id="导出"><i class="iconfont icon-daochu"></i>导出<span v-if="confirmTxt > 0">{{
							confirmTxt }}</span></el-button>
					<el-popover ref="popover2" trigger="click">
						<div style="text-align: left;padding-left: 20px;padding-top: 8px;">
							<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
								@change="handleCheckAllChange">全选</el-checkbox>
							<div style="margin: 15px 0;"></div>
							<el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
								<el-checkbox style="display: block;" class="salesWater_checkbox" v-for="city in cities" :label="city"
									:key="city">{{ city }}</el-checkbox>
							</el-checkbox-group>
						</div>
					</el-popover>
				</div>
			</div>
		</div>

		<div class="pulbic_oparetionBlock public_statisticsInfo">
			<div class="public_statistics billDetails-statistics">
				<div class="public_statisticsContent">
					<img class="imgStatistics" src="../../assets/images/orderStatistics/yhqffze.png">
					<!-- <i style="color: #FF9E4F!important;font-size: 20px;" class="iconfont icon-chongzhi1"></i> -->
					<div class="payType">发放</div>
				</div>
				<ul class="billDetails-ul">
					<li class="pulic_statistics_titlt"><span class="totolTitle">优惠券发放总额(元)</span><span class="Amount"
							style="color: #199FFF;">{{ zzc }}</span></li>
					<!-- <li class="pulic_statistics_titlt"><span class="totolTitle">结算车次(单)</span><span class="singular">{{jscc}}</span></li> -->
				</ul>
			</div>
			<!-- <div class="public_statistics billDetails-statistics">
				<div class="public_statisticsContent">
				<i style="color: #30A8FF!important;font-size: 20px;"  class="iconfont icon-hongchong-copy"></i>
				<div class="payType">红冲</div>
				</div>
				<ul class="billDetails-ul">
					<li class="pulic_statistics_titlt"><span class="totolTitle">总金额(元)</span><span class="Amount" style="color: #FF5A45;">{{hcSum}}</span></li>
					<li class="pulic_statistics_titlt"><span class="totolTitle">总单数(单)</span><span class="singular">{{hcCount}}</span></li>
				</ul>
			</div> -->
			<div class="public_statistics billDetails-statistics">
				<div class="public_statisticsContent">
					<img class="imgStatistics" src="../../assets/images/orderStatistics/zlxyh.png">
					<div class="payType">用户</div>
				</div>
				<ul class="billDetails-ul">
					<li class="pulic_statistics_titlt"><span class="totolTitle">获得优惠券用户数(人)</span><span class="Amount"
							style="color: #08D691;">{{ zrs }}</span></li>
					<!-- <li class="pulic_statistics_titlt"><span class="totolTitle">结算金额(元)</span><span class="singular">{{jsje}}</span></li> -->
				</ul>
			</div>
			<div class="public_statistics billDetails-statistics">
				<div class="public_statisticsContent">
					<img class="imgStatistics" src="../../assets/images/orderStatistics/wsyq.png">
					<!-- <i style="color: #08D691 !important;font-size: 20px;" class="iconfont icon-tuikuan1"></i> -->
					<div class="payType">未使用</div>
				</div>
				<ul class="billDetails-ul">
					<li class="pulic_statistics_titlt"><span class="totolTitle">未使用总额(元)</span><span class="Amount"
							style="color: #FF4500;">{{ wsy }}</span></li>
					<!-- <li class="pulic_statistics_titlt"><span class="totolTitle">结算重量(吨)</span><span class="singular">{{jszl}}</span></li> -->
				</ul>
			</div>
			<div class="public_statistics billDetails-statistics">
				<div class="public_statisticsContent">
					<img class="imgStatistics" src="../../assets/images/orderStatistics/ysyq.png">
					<!-- <i style="color: #08D691 !important;font-size: 20px;" class="iconfont icon-tuikuan1"></i> -->
					<div class="payType">已使用</div>
				</div>
				<ul class="billDetails-ul">
					<li class="pulic_statistics_titlt"><span class="totolTitle">已使用总额(元)</span><span class="Amount"
							style="color: #FF4500;">{{ ysh }}</span></li>
					<!-- <li class="pulic_statistics_titlt"><span class="totolTitle">结算重量(吨)</span><span class="singular">{{jszl}}</span></li> -->
				</ul>
			</div>

		</div>
		<div class="billOperationRecord-table pulbic_table_container">
			<el-table tooltip-effect="dark" :data="tableData" style="width: 100%;"
				:default-sort="{ prop: 'waterNum', order: 'descending' }"
				:header-cell-style="{ color: 'rgba(51,51,51,1)', background: 'rgba(184,227,255,1)', 'font-weight': 'bold' }"
				class="public_tableColumn">

				<el-table-column prop="ORMTB410CA00" label="客户名称">
					<template slot-scope="scope">
						<p>
							<span>{{ scope.row.ORMTB410CA00 }}</span>
						</p>
						<p style="color: #999;">
							<span>{{ scope.row.pertb008CA09 }}</span>
						</p>

					</template>
				</el-table-column>
				<el-table-column prop="SETTB409CA05" label="优惠券类型">
				</el-table-column>
				<el-table-column prop="SETTB409CB07" label="获得渠道">
				</el-table-column>
				<el-table-column prop="SETTB409CB02" label="使用时间">
				</el-table-column>
				<el-table-column prop="SETTB409CB08" label="使用厂家">
				</el-table-column>
				<el-table-column prop="SETTB409CB06" label="到期时间">
				</el-table-column>
				<el-table-column prop="SETTB409CA01" label="优惠券总额">
				</el-table-column>
				<el-table-column prop="SETTB409CA01" label="优惠券状态">
					<template slot-scope="scope">
						<p>
							<el-tag type="info" v-if="scope.row.SETTB409CB03 == '0'">未使用</el-tag>
							<el-tag type="warning" v-if="scope.row.SETTB409CB03 == '1'">使用中</el-tag>
							<el-tag type="success" v-if="scope.row.SETTB409CB03 == '2'">已使用</el-tag>
							<el-tag type="danger" v-if="scope.row.SETTB409CB03 == '3'">已过期</el-tag>

						</p>

					</template>
				</el-table-column>

				<!-- <el-table-column prop="ysy" label="已使用">
				</el-table-column>
				<el-table-column prop="wsy" label="未使用">
				</el-table-column> -->

			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
					layout="total,sizes, prev, pager, next" :total="pagingPageMo">
				</el-pagination>
			</div>
		</div>
		<div class="public-dialog">
			<el-dialog title="详情" :visible.sync="oerderDetilsShow" width="35%" @close="detailsList = ''"
				:closeOnClickModal='false'>
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">流水号</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA00 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA05 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">客户名称</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA03 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA01 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单方式</div>
						<div class="DWD-li-text">
							{{ detailsList.ORMTB440CF00 == 'ZG' ? '直供' : detailsList.ORMTB440CF00 == 'LS' ? '零售' :
								detailsList.ORMTB440CF00 == 'QD' ? '抢单' : '' }}
						</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单时间</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA19 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">结算时间</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CC00 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">回执时间</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CE00 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">原因</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CD01 || '' }}</div>
					</div>
					<div class="DWD-table">
						<div class="DWD-table-left-title">
							<div></div>
							<div>派单</div>
							<div>结算</div>
							<div>回执</div>
						</div>
						<div class="DWD-table-left-flex">
							<div>物料</div>
							<div>{{ detailsList.ORMTB440CA07 || '' }}</div>
							<div>{{ detailsList.ORMTB440CC02 || '' }}</div>
							<div></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>单价</div>
							<div>{{ detailsList.ORMTB440CA08 || '' }}</div>
							<div>{{ detailsList.ORMTB440CC03 || '' }}</div>
							<div></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>重量</div>
							<div>{{ detailsList.ORMTB440CA10 || 0 }}</div>
							<div>{{ detailsList.ORMTB440CC04 || 0 }}</div>
							<div v-if="detailsList.ORMTB440CF01 == '5'">{{ detailsList.ORMTB440CE09 || 0 }}</div>
							<div v-else></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>物料金额</div>
							<div>{{ detailsList.ORMTB440CA11 || 0 }}</div>
							<div>{{ detailsList.ORMTB440CC06 || 0 }}</div>
							<div></div>
						</div>
						<div class="DWD-table-left-flex">
							<div>运费金额</div>
							<div>{{ detailsList.ORMTB440CA12 || 0 }}</div>
							<div>{{ detailsList.jsORMTB440CA12 || 0 }}</div>
							<div v-if="detailsList.ORMTB440CF01 == '5'">{{ detailsList.ORMTB440CE10 || 0 }}</div>
							<div v-else></div>
						</div>
					</div>
				</div>
				<div class="DetailsWater-img">
					<div class="DetailsWater-img-text">回执记录</div>
					<el-image style="width: 80px; height: 80px" :src="DetailsWaterurl" :preview-src-list="DetailsWatersrcList">
					</el-image>
				</div>
				<div v-if="detailsList.ORMTB440CH05" class="DetailsWater-img">
					<div class="DetailsWater-img-text">磅单</div>
					<el-image style="width: 80px; height: 80px" :src="detailsList.ORMTB440CH05"
						:preview-src-list="DetailsWeightrcList">
					</el-image>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="审核" :visible.sync="orderAuditShow" @close="detailsList = ''" width="30%"
				:closeOnClickModal='false'>
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA05 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">客户名称</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA03 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">物料名称</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA07 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">重量</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA10 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA01 || '' }}</div>
					</div>
				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="orderAuditServe(1)">通过</el-button>
					<el-button type="danger" @click="orderAuditServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="审核" :visible.sync="isorderAuditShow" @close="detailsList = '', isorderAuditText = ''"
				width="30%" :closeOnClickModal='false'>
				<div class="DetailsWater-Dialog">
					<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA05 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">客户名称</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA03 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">物料名称</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA07 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">重量</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA10 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">车牌号</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA01 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单物料金额</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA11 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">派单运费</div>
						<div class="DWD-li-text">{{ detailsList.ORMTB440CA12 || '' }}</div>
					</div>
					<div class="DWD-li">
						<div class="DWD-li-title">审核说明</div>
						<div class="DWD-li-text">
							<input type="text" v-model="isorderAuditText" maxlength="20">
						</div>
					</div>

				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="isorderAuditServe(1)">通过</el-button>
					<el-button type="danger" @click="isorderAuditServe(2)">拒绝</el-button>
				</div>
			</el-dialog>
		</div>

		<div class="public-dialog">
			<el-dialog title="详情" :visible.sync="inputWeightShow" @close="inputWeightClose" width="30%"
				:closeOnClickModal='false'>
				<div class="CustomerfillingDig-tab">
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">派单物料：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<!-- <input type="text" v-model="detailsList.ORMTB440CA07" disabled> -->
							<el-select v-model="materialValue" placeholder="请选择" @change="materialChange">
								<el-option v-for="item in materialList" :key="item.value" :label="item.lable" :value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">单价：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="number" v-model="weightOpt.price" maxlength="10" @input="inputWeightFormat($event, 'price')">
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">毛重：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="number" v-model="weightOpt.tare" maxlength="10" @input="inputWeightFormat($event, 'tare')">
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">皮重：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="number" v-model="weightOpt.gross" maxlength="10" @input="inputWeightFormat($event, 'gross')">
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">净重：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="text" v-model="detailsList.ORMTB440CC04" maxlength="10" disabled>
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
					<div class="CustomerfillingDig-tab-li">
						<div class="CustomerfillingDig-tab-li-text">结算金额：</div>
						<div class="CustomerfillingDig-tab-li-ipt">
							<input type="text" v-model="detailsList.ORMTB440CC06" maxlength="100" disabled>
						</div>
						<div class="CustomerfillingDig-tab-li-b"></div>
					</div>
				</div>
				<div style="margin-top: 20px;text-align: center;">
					<el-button type="primary" @click="inputWeightConfirm">确定</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import qs from 'qs'
import {
	createLogger
} from 'vuex';
import debounce from '../../api/debounce';
export default {
	data() {
		return {
			weightOpt: {
				tare: '',
				gross: '',
				price: ''
			},
			loadingBut: false,
			confirmTxt: 0,
			inputWeightShow: false, // 输入磅单信息弹窗
			isorderAuditText: '',
			oerderDetilsShow: false,
			orderAuditShow: false,
			isorderAuditShow: false,
			returnReceiptShow: false,
			uobj: this.$store.state.uobj, //登陆缓存--用户信息
			date: [], //日期
			startTime: '',
			endTime: '',
			dateNowDayActive: false,
			dateYesterdayActive: false,
			dateNowMonthActive: false,
			dateLastMonthActive: false,
			twolevelUserLogin: true,
			timeIndex: 0, //判断第几次切换当月时间
			sameMonthTime: '', //目前月份
			currentMonthTime: '', //目前月份--上月+1
			tableData: [],
			ORMTB440CA00: '',
			cusQueryiphone: '',
			materialOptions: [],
			materialTypeValue: '',
			customerOptions: [{
				ORMTB410ID: '',
				ORMTB410CA00: '全部',
			}],
			carNum: '',
			materielMo: '',
			materielOptions: [{
				SETTB109CA00: '全部',
				SETTB109ID: '',
			}],

			wsy: 0,
			ysh: 0,
			zrs: 0,
			zzc: 0,
			// 查询
			customerMo: '', //客户--查询		
			SETTB122CA07: '', //优惠券状态
			billOperationAdd: false,
			enterpriseTwoOptionList: [{
				SETTB109CA00: '全部',
				SETTB109ID: '',
			}], //二级企业下拉框--新增
			enterpriseTwo: '', //二级企业
			carNumber: '', //车牌号
			pageMo: 1, //默认列表页码
			limitMo: 10, //每页的条数
			pagingPageMo: 0, //分页--数据列表共有的条数
			currentPage: 1, //设置当前页默认为1
			// 列设置
			checkAll: true,
			checkedCities: ['派单时间', '派单编号', '企业名称', '客户名称', '车牌号', '订单物料', '完成物料', '重量', '完成状态', '申请状态'],
			cities: ['派单时间', '派单编号', '企业名称', '客户名称', '车牌号', '订单物料', '完成物料', '重量', '完成状态', '申请状态'],
			isIndeterminate: false,
			// 详情
			billOperationDetails: false,
			detailsList: '', //详情列表
			tableHeadList: [
				// {
				// 	prop: 'ORMTB440CA19',
				// 	label: '派单时间',
				// 	width: 110
				// },
				// {
				// 	prop: 'ORMTB440CA00',
				// 	label: '派单编号',
				// 	width: 130
				// },
				// {
				// 	prop: 'ORMTB440CA05',
				// 	label: '企业名称',
				// },
				// {
				// 	prop: 'ORMTB440CA03',
				// 	label: '客户名称',
				// },

				{
					prop: 'ORMTB440CA01',
					label: '车牌号',
					width: 100
				},
				{
					prop: 'ORMTB440CA07',
					label: '订单物料',
					width: 100
				},
				{
					prop: 'ORMTB440CC02',
					label: '完成物料',
					width: 100
				},
				{
					prop: 'ORMTB440CA10',
					label: '重量',
				},
				{
					prop: 'ORMTB440CC00',
					label: '结算时间',
					width: 110
				},
				{
					prop: 'ORMTB440CC06',
					label: '结算金额',
					width: 110
				},
				{
					prop: 'ORMTB440CC07',
					label: '流水号',
					width: 130
				}
				// {
				// 	prop: 'ORMTB440CF01text',
				// 	label: '完成状态',
				// 	width: 100
				// }
				// {
				// 	prop: 'auditText',
				// 	label: '申请状态',
				// 	width: 100
				// }
			],
			tableHeadListInit: [{
				prop: 'ORMTB440CA19',
				label: '派单时间',
			},
			{
				prop: 'ORMTB440CA00',
				label: '派单编号',
			},
			{
				prop: 'ORMTB440CA05',
				label: '企业名称',
			},
			{
				prop: 'ORMTB440CA03',
				label: '客户名称',
			},

			{
				prop: 'ORMTB440CA01',
				label: '车牌号',
			},
			{
				prop: 'ORMTB440CA07',
				label: '订单物料',
			},
			{
				prop: 'ORMTB440CC02',
				label: '完成物料',
			},
			{
				prop: 'ORMTB440CA10',
				label: '重量',
			},
			{
				prop: 'ORMTB440CF01text',
				label: '完成状态',
			},
			{
				prop: 'auditText',
				label: '申请状态',
			},
			],
			isRefresh: true,
			isRefreshSetInterval: '',
			// quanpDisabled: false,
			// 历史缓存
			currentUrl: this.$route.path,
			historyInfo: '',
			// 时间限制
			// 限制开始日期不能超过当前日期
			startDateDisabled: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				}
			},
			solelist: [],
			DetailsWaterurl: '',
			DetailsWatersrcList: [],
			DetailsWeightrcList: [],
			materialList: [],
			dataStatusOperation: [{
				value: '',
				label: '全部'
			}, {
				value: '0',
				label: '未使用'
			}, {
				value: '1',
				label: '使用中'
			}, {
				value: '2',
				label: '已使用'
			}, {
				value: '3',
				label: '已过期'
			}],
			materialValue: '',
			listTick: null, // 列表刷新定时器
			timeType: '1'
		}
	},
	watch: {
		weightOpt: {
			handler(val) {
				if ((val.tare || val.tare === 0) && (val.gross || val.gross === 0) && (val.price || val.price === 0)) {
					let tare = parseFloat(val.tare)
					let gross = parseFloat(val.gross)
					this.detailsList.ORMTB440CC04 = (tare - gross).toFixed(2)
					if (this.detailsList.ORMTB440CC04) {
						debounce(this.getSettlementAmount, 500)
					}
				} else {
					this.detailsList.ORMTB440CC04 = ''
					this.detailsList.ORMTB440CC06 = ''
				}
			},
			deep: true
		},
		// 'detailsList.ORMTB440CA04'() {
		//     this.getSelectMaterial()
		// }
	},
	created() {
		var list = "";
		list = this.$store.state.solelist;
		// console.log(list)
		// 赋值，缓存销毁
		this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
		sessionStorage.removeItem(this.currentUrl)
		if (this.historyInfo != null && this.historyInfo != '') {
			this.init()
		}
		// console.log(this.historyInfo)
		// else {
		// 	this.getNowDay();
		// }
		var path = this.$route.path;
		if (path === '/marKetingCoupon') {
			path = '/Home' + path
		}
		this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
	},
	mounted() {
		if (this.historyInfo == null && this.$route.query.mark == null) {
			this.getNowDay();
			this.startTime = this.date[0];
			this.endTime = this.date[1];
			this.dateNowDayActive = true
		}

		// this.optionLists()
		this.enterprise0ptions()
		this.queryClick()
		// this.listTick = setInterval(() => {
		// 	this.queryClick()
		// }, 1000 * 60)
		// console.log(this.$store.state.uobj)
	},
	// 存储数据
	beforeDestroy() {
		clearInterval(this.listTick)
		this.listTick = null
		this.startTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[0]));
		this.endTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[1]));
		var obj = {
			startTime: this.startTime,
			endTime: this.endTime, //开始时间
			ORMTB440CA02: this.ORMTB440CA02, //客户id
			ORMTB400CA03: this.ORMTB400CA03, //客户名称
			ORMTB440CA04: this.ORMTB440CA04, //客户名称
			ORMTB440CA06: this.ORMTB440CA06, //二级企业id
			ORMTB440CF01: this.ORMTB440CF01, //二级企业名称
			ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
			ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
			currentPage: this.currentPage, //当前页数
			pageMo: this.pageMo, //页码
			limitMo: this.limitMo, //每页条数
			dateNowDayActive: this.dateNowDayActive,
			dateYesterdayActive: this.dateYesterdayActive,
			dateNowMonthActive: this.dateNowMonthActive,
			dateLastMonthActive: this.dateLastMonthActive,
			ORMTB440CA00: this.ORMTB440CA00
		}
		sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
	},
	methods: {
		// 值改变 重新获取结算金额
		async materialChange(val) {
			if (val == this.detailsList.ORMTB440CC01) {
				this.weightOpt.price = this.detailsList.ORMTB440CA08
			} else {
				await this.queryMaterialPrice(val)
			}
			this.getSettlementAmount()
		},
		// 根据物料id 查询单价
		async queryMaterialPrice(ORMTB440CC01) {
			let url = '/orm/ormtb440/unitPriceAuto'
			let params = {
				ORMTB440CC01, // 结算物料id
				ORMTB440CA02: this.detailsList.ORMTB440CA02, //客户id
				ORMTB440CA04: this.detailsList.ORMTB440CA04, // 二级企业ID
			}
			params = qs.stringify(params)
			let header = {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
			let res = await this.axios.post(url, params, {
				header
			})
			if (res.data.code === 200) {
				this.weightOpt.price = res.data.data
			}
		},
		// 获取派单物料列表
		getSelectMaterial() {
			var postData = {
				SETTB99ID: this.detailsList.ORMTB440CA04
			}
			this.materialList = []
			postData = qs.stringify(postData)
			var url = "/set/settb109/select_material";
			this.axios.post(url, postData, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then(res => {
				if (res.data.code == 200) {
					this.materialList = res.data.data
					// this.materialValue = this.detailsList.ORMTB440CC01
					if (this.detailsList.ORMTB440CC01) {
						this.materialValue = this.detailsList.ORMTB440CC01
					} else {
						this.materialValue = this.detailsList.ORMTB440CA06
						this.queryMaterialPrice(this.materialValue)
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		//初始化数据
		init() {
			this.startTime = this.historyInfo.startTime
			this.endTime = this.historyInfo.endTime
			this.date = [this.startTime, this.endTime]
			this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
			this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
			this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
			this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
			this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
			this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
			this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
			this.currentPage = this.historyInfo.currentPage
			this.pageMo = this.historyInfo.pageMo
			this.limitMo = this.historyInfo.limitMo
			this.dateNowDayActive = this.historyInfo.dateNowDayActive
			this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
			this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
			this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
			this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
		},
		// 导出
		exports() {
			// console.log(this.uobj)
			if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
				this.customerMo = this.uobj.ormtb410.ORMTB410ID //一级企业id

			}
			var startTime = this.date[0]; //开始时间
			var endTime = this.date[1]; //结束时间
			var ORMTB440CA02 = this.customerMo; //二级客户ID
			var ORMTB400CA03 = 1002; //一级客户代码
			var ORMTB440CA04 = this.enterpriseTwo; //二级企业ID
			var ORMTB440CA06 = this.materielMo; //物料ID
			var ORMTB440CF01 = this.SETTB122CA07; //状态
			var ORMTB440CA00 = this.ORMTB440CA00; //订单号
			var ORMTB440CA01 = this.carNumber; //车牌号
			var timeType = this.timeType; //
			var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb440toExcle?startTime=" + startTime +
				"&endTime=" +
				endTime + "&ORMTB440CA02=" + ORMTB440CA02 + "&ORMTB400CA03=" + ORMTB400CA03 +
				"&ORMTB440CA04=" + ORMTB440CA04 + "&ORMTB440CA06=" + ORMTB440CA06 + "&ORMTB440CF01=" +
				ORMTB440CF01 + "&ORMTB440CA00=" + ORMTB440CA00 + "&ORMTB440CA01=" + ORMTB440CA01 + "&timeType=" +
				timeType;
			window.location.href = url;

			this.loadingBut = true
			var timer = null //倒计时
			this.confirmTxt = 30 - 1
			timer = setInterval(() => {
				if (this.confirmTxt === 0) {
					this.confirmTxt = ""
					this.loadingBut = false
					clearInterval(timer);
				} else {
					this.confirmTxt--
				}
			}, 1000);

		},
		topWeightInput() {
			this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/^\./g, ""); //验证第一个字符是数字
			this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(".", "$#$").replace(/\./g, "")
				.replace("$#$", ".");
			this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(/^(\-)*(\d+)\.(\d\d).*$/,
				'$1$2.$3'); //只能输入两个小数
			if (this.detailsList.ORMTB440CE02.indexOf(".") < 0 && this.detailsList.ORMTB440CE02 !=
				"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				this.detailsList.ORMTB440CE02 = parseFloat(this.detailsList.ORMTB440CE02);
			}
			this.$refs.topWeight.value = this.detailsList.ORMTB440CE02
		},
		topWeightChange() {
			var index = String(this.detailsList.ORMTB440CE02).indexOf('.')
			if (index == -1) return
			var numArr = this.detailsList.ORMTB440CE02.split('.')
			if (numArr[1].length == 0) {
				this.$refs.topWeight.value = numArr[0]
				this.detailsList.ORMTB440CE02 = numArr[0]
			} else {
				this.$refs.topWeight.value = numArr[0] + '.' + numArr[1]
				this.detailsList.ORMTB440CE02 = numArr[0] + '.' + numArr[1]
			}
		},
		topMoneyInput() { //充值金额实时校验
			this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/^\./g, ""); //验证第一个字符是数字
			this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(".", "$#$").replace(/\./g, "")
				.replace("$#$", ".");
			this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(/^(\-)*(\d+)\.(\d\d).*$/,
				'$1$2.$3'); //只能输入两个小数
			if (this.detailsList.ORMTB440CA21.indexOf(".") < 0 && this.detailsList.ORMTB440CA21 !=
				"") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				this.detailsList.ORMTB440CA21 = parseFloat(this.detailsList.ORMTB440CA21);
			}
			this.$refs.topMoney.value = this.detailsList.ORMTB440CA21
		},
		topMoneyChange() { //充值金额失去焦点数据处理
			var index = String(this.detailsList.ORMTB440CA21).indexOf('.')
			if (index == -1) return
			var numArr = this.detailsList.ORMTB440CA21.split('.')
			if (numArr[1].length == 0) {
				this.$refs.topMoney.value = numArr[0]
				this.detailsList.ORMTB440CA21 = numArr[0]
			} else {
				this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
				this.detailsList.ORMTB440CA21 = numArr[0] + '.' + numArr[1]
			}
		},
		// 取消订单
		cancelOrder(row) {
			var url = "/orm/ormtb440/updateORMTB440CF01";
			this.$prompt('请输入取消原因', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /^.{1,}$/,
				inputErrorMessage: '原因不能为空'
			}).then(({
				value
			}) => {
				var postData = {
					ORMTB440ID: row.ORMTB440ID,
					ORMTB440CF01: -1, //状态
					ORMTB440CD01: value, //取消原因
				}
				let loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url, postData).then(res => {
					if (res.data.code == 200) {
						this.pageList()
						this.$message({
							type: 'success',
							message: '取消成功!'
						});
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					loading.close();
				}).catch(() => {
					loading.close();
				})
			})
		},
		// 客户--查询
		enterprise0ptions() {
			var postData = {}
			if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
				postData = {
					ORMTB400ID: this.uobj.ormtb410.ORMTB410ID //一级企业id
				}
			}
			if (this.uobj.pertb005.pertb005cb00 == "CUS-1") {
				postData = {
					ORMTB400ID: this.uobj.ormtb400.ORMTB400ID //一级企业id
				}
			}

			var List = [{
				ORMTB410ID: '',
				ORMTB410CA00: '全部',
			}];
			var url = "/orm/ormtb410/selectOrmtb410s";
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					// 客户
					this.customerOptions = [...List, ...res.data.data];
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			})
		},
		materielMoPost() {
			var i = (this.enterpriseTwoOptionList || []).findIndex((profile) => profile.SETTB99ID === this
				.enterpriseTwo);
			var url = "/set/settb109/selectPageList";
			var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
			var data = {
				SETTB109CA03: '',
				SETTB109CA00: '',
				SETTB109CD01: SETTB100ID,
				SETTB99ID: this.enterpriseTwo,
				page: 1,
				limit: 1000,
			};
			var List = [{
				SETTB109CA00: '全部',
				SETTB109ID: '',
			}];
			this.axios.post(url, data).then(res => {
				if (res.data.code == 200) {
					this.materielOptions = [...List, ...res.data.data];
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			})
		},
		erpChange() {
			if (this.enterpriseTwo != '') {
				this.materielMoPost()
			} else {
				this.materielOptions = [{
					SETTB109CA00: '全部',
					SETTB109ID: '',
				}]
			}
		},
		// 获取下拉框信息--二级企业
		optionLists() {
			var postData = {
				SETTB100CA02: '', //用户类型
			}
			if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
				postData = {
					ORMTB400ID: this.uobj.ormtb410.ORMTB400ID //一级企业id
				}
			}
			if (this.uobj.pertb005.pertb005cb00 == "CUS-1") {
				postData = {
					ORMTB400ID: this.uobj.ormtb400.ORMTB400ID //一级企业id
				}
			}
			// var postData = {
			// 	SETTB100CA02: '', //用户类型
			// 	ORMTB400ID: this.uobj.ormtb400.ORMTB400ID //一级企业id
			// }
			var List = [{
				SETTB99ID: '',
				SETTB99CA00: '全部',
			}];
			var url = "/set/settb100/selectSettb100ByCa02";
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					var data = res.data.data
					// 二级企业
					this.enterpriseTwoOptionList = [...List, ...data];
					if (this.enterpriseTwoOptionList.length == 2) {
						this.enterpriseTwo = this.enterpriseTwoOptionList[1].SETTB99ID
						this.materielMoPost()
					}
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
				this.pageList()
			}).catch(() => {
				this.pageList()
				loading.close();
			})
		},
		// 查询
		queryClick() {
			this.startTime = this.date[0];
			this.endTime = this.date[1];
			this.pageList()
		},
		// 列表
		pageList() {
			var ORMTB400CA03
			// console.log(this.uobj.ormtb410)
			if (this.uobj.pertb005.pertb005cb00 == "CUS-2") {
				ORMTB400CA03 = this.uobj.ormtb410.ORMTB410ID
			}
			if (this.uobj.pertb005.pertb005cb00 == "CUS-1") {
				ORMTB400CA03 = this.uobj.ormtb400.ORMTB400CA03
			}

			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				startTime: this.startTime, //开始时间
				endTime: this.endTime, //结束时间
				ORMTB410ID: this.customerMo, //二级客户ID
				phone: this.cusQueryiphone, //手机号
				SETTB409CB03: this.SETTB122CA07,//优惠券状态
				page: this.pageMo,
				limit: this.limitMo
				// timeType: this.timeType
			}
			this.tableData = [];
			var url = "/set/settb409/selectPageList2";
			this.axios.post(url, postData).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				// console.log(res)
				if (res.data.code == 200) {
					// console.log(res)
					var data = res.data.data.list;
					// console.log(data)
					this.pagingPageMo = res.data.count;

					this.tableData = data;
					this.zrs = res.data.data.zrs
					this.wsy = res.data.data.wsy
					this.ysh = res.data.data.ysh
					this.zzc = res.data.data.zzc
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		UploadClick(row) {
			this.ormtb440ca00 = row.ORMTB440CA00
		},
		inputFileChange(e) {
			let file = e.target.files[0]
			let formData = new FormData()
			formData.append('file', file)
			formData.append('ormtb440ca00', this.ormtb440ca00)
			let loading = this.$loading({
				lock: true,
				text: '上传中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var url = "/orm/ormtb440/upload";
			this.axios.post(url, formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					this.$message({
						message: '上传成功',
						type: 'success'
					});
					this.pageList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		inputWeightClick(row) {
			this.inputWeightShow = true
			this.querydetile(row)
		},
		inputWeightClose() {
			this.weightOpt.tare = ''
			this.weightOpt.gross = ''
			this.detailsList.ORMTB440CC02 = ''
			this.detailsList.ORMTB440CC02 = ''
			this.detailsList.ORMTB440CC04 = ''
			this.detailsList.ORMTB440CC06 = ''
		},
		// 获取结算金额
		async getSettlementAmount() {
			if (!this.materialValue) return
			if (this.weightOpt.price < 0) return
			if (!this.detailsList.ORMTB440CC04) return
			var params = {
				ORMTB440CC01: this.materialValue,
				ORMTB440CA02: this.detailsList.ORMTB440CA02,
				ORMTB440CA04: this.detailsList.ORMTB440CA04,
				ORMTB440CC03: this.detailsList.ORMTB440CC03,
				ORMTB440CC04: this.detailsList.ORMTB440CC04,
				ORMTB440CC03: this.weightOpt.price
			}
			params = qs.stringify(params)
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var url = "/orm/ormtb440/orderCompleteBeforeBack";
			this.axios.post(url, params, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					this.detailsList.ORMTB440CC06 = res.data.data
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		inputWeightConfirm() {
			var {
				ORMTB440ID, // 派单记录ID - 隐藏
				ORMTB440CC04, // 结算重量 -不修改
				// ORMTB440CC06, // 结算金额 -可修改
			} = this.detailsList
			var ORMTB440CC01 = this.materialValue // 物料id
			var ORMTB440CA07 = this.materialList.find(em => em.value === this.materialValue).lable // 结算物料 -可修改
			var {
				tare,
				gross
			} = this.weightOpt
			if (!tare) {
				return this.$message({
					message: '请输入毛重',
					type: 'error'
				});
			}
			if (!gross) {
				return this.$message({
					message: '请输入皮重',
					type: 'error'
				});
			}
			var params = {
				ORMTB440ID,
				ORMTB440CC01, // 物料id
				ORMTB440CC02: ORMTB440CA07,
				ORMTB440CC04,
				ORMTB440CC03: this.weightOpt.price
			}
			params = qs.stringify(params)

			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var url = "/orm/ormtb440/update";
			this.axios.post(url, params, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					this.tableData = [];
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.inputWeightShow = false
					this.pageList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		inputWeightFormat(e, type) {
			let value = e.target.value
			value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			value = value.replace(/^\./g, ""); //验证第一个字符是数字
			value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				value = parseFloat(value);
			}
			setTimeout(() => {
				this.weightOpt[type] = value
			}, 0);
		},
		inputWeightTotalFormat(e) {
			let value = e.target.value
			value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
			value = value.replace(/^\./g, ""); //验证第一个字符是数字
			value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
			value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
			value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
			if (value.indexOf(".") < 0 && value != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
				value = parseFloat(value);
			}
			this.detailsList.ORMTB440CC06 = value
		},
		// 详情
		DetailsClick(row) {
			this.oerderDetilsShow = true;
			this.querydetile(row)
		},
		orderAudit(row) {
			this.orderAuditShow = true
			this.querydetile(row)
		},
		isorderAudit(row) {
			this.isorderAuditShow = true
			this.querydetile(row)
		},
		returnReceipt(row) {
			this.returnReceiptShow = true
			this.querydetile(row)
		},
		orderAuditServe(type) {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB440CG00: type,
				ORMTB440CG02: this.uobj.pertb005.pertb005ca02,
				ORMTB440ID: this.detailsList.ORMTB440ID,
				ORMTB440CA02: this.detailsList.ORMTB440CA02,
				ORMTB440CA11: this.detailsList.ORMTB440CA11,
				ORMTB440CA12: this.detailsList.ORMTB440CA12,
			}
			this.tableData = [];
			var url = "/orm/ormtb440/updateORMTB440CG00";
			this.axios.post(url, postData).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					this.$message({
						message: '审核成功',
						type: 'success'
					});
					this.orderAuditShow = false
					this.pageList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		isorderAuditServe(type) {
			let loading = this.$loading({
				lock: true,
				text: '请求中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.5)'
			});
			var postData = {
				ORMTB440CH01: type,
				ORMTB440CH03: this.uobj.pertb005.pertb005ca02,
				ORMTB440ID: this.detailsList.ORMTB440ID,
				ORMTB440CA02: this.detailsList.ORMTB440CA02,
				ORMTB440CA11: this.detailsList.ORMTB440CA11,
				ORMTB440CA12: this.detailsList.ORMTB440CA12,
				ORMTB440CH04: this.isorderAuditText,
			}
			this.tableData = [];
			var url = "/orm/ormtb440/updateORMTB440CH01";
			this.axios.post(url, postData).then(res => {
				setTimeout(() => {
					loading.close()
				}, 400)
				if (res.data.code == 200) {
					this.$message({
						message: '审核成功',
						type: 'success'
					});
					this.isorderAuditShow = false
					this.pageList()
				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			}).catch(() => {
				loading.close();
			})
		},
		querydetile(row) {
			var postData = {
				ORMTB440ID: row.ORMTB440ID, //流水id
			}
			this.detailsList = ''
			var url = "/orm/ormtb440/selectDetails";
			this.axios.post(url, postData).then(res => {
				if (res.data.code == 200) {
					this.detailsList = res.data.data;
					this.DetailsWatersrcList = [this.detailsList.ORMTB440CE01]
					if (this.detailsList.ORMTB440CH05) this.DetailsWeightrcList = [this.detailsList
						.ORMTB440CH05
					]
					this.DetailsWaterurl = this.detailsList.ORMTB440CE01
					if (this.detailsList.ORMTB440CF01 == 6 || (row.ORMTB440CF01 == 0 && row.ORMTB440CA22)) {
						this.weightOpt.price = this.detailsList.ORMTB440CC03
						if (this.detailsList.ORMTB440CC06 == 0) this.detailsList.ORMTB440CC06 = ''
						this.weightOpt.tare = this.detailsList.ORMTB440CC05
						this.weightOpt.gross = (this.detailsList.ORMTB440CC05 - this.detailsList.ORMTB440CC04)
							.toFixed(2)
						this.getSelectMaterial()
					}
					// else if (this.detailsList.ORMTB440CF01 == 0) {
					// 	this.weightOpt.price = this.detailsList.ORMTB440CC03
					// 	this.getSelectMaterial()
					// } 

				} else {
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}

			})
		},
		handleCheckAllChange(val) {
			this.checkedCities = val ? this.cities : [];
			this.isIndeterminate = false;
			this.tableHeadList = val ? this.tableHeadListInit : []
		},
		handleCheckedCitiesChange(value) {
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.cities.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
			var changearr = this.checkedCities;
			var initarr = this.tableHeadListInit;
			this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr);
		},


		dateFtt(fmt, date) { //author: meizz
			var o = {
				"M+": date.getMonth() + 1, //月份 
				"d+": date.getDate(), //日 
				"h+": date.getHours(), //小时 
				"m+": date.getMinutes(), //分 
				"s+": date.getSeconds(), //秒 
				"q+": Math.floor((date.getMonth() + 3) / 3), //季度 
				"S": date.getMilliseconds() //毫秒 
			};
			if (/(y+)/.test(fmt))
				fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
			for (var k in o)
				if (new RegExp("(" + k + ")").test(fmt))
					fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
						.length)));
			return fmt;
		},

		//获取当前时间
		getNowDay() {
			var date = new Date().getTime();
			var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
			var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
			var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
			data = `${data} ${this.exchangeTiem || '00:00:00'}`
			enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
			this.date = [enddata, data];
			this.dateNowDayActive = true
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		datePickerChange(e) {
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		//获取昨天时间
		getYesterday() {
			var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
			var Ming = new Date().getTime();
			var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
			var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
			nowDay = `${nowDay} ${this.exchangeTiem || '00:00:00'}`
			enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
			this.date = [nowDay, enddata];
			this.dateNowDayActive = false
			this.dateYesterdayActive = true
			this.dateNowMonthActive = false
			this.dateLastMonthActive = false
		},
		//获取当月时间
		sameMonth() {
			var date = new Date();
			var hms = date.setDate(1);
			var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
			firstDay = `${firstDay} ${this.exchangeTiem || '00:00:00'}`
			var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
			var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
			nextDay = `${nextDay} ${this.exchangeTiem || '00:00:00'}`
			this.date = [firstDay, nextDay];
			this.startTime = this.date[0];
			this.endTime = this.date[1];
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = true
			this.dateLastMonthActive = false
		},
		//获取上月时间
		lastMonth() {
			var nowdays = new Date();
			var year = nowdays.getFullYear();
			var month = nowdays.getMonth();
			var lastyear = year
			var lastmonth = month
			if (month == 0) {
				month = 12;
				year = year - 1;
			}
			if (month == 12) {
				lastmonth = 1
			} else {
				lastmonth = lastmonth + (1 * 1)
			}
			if (month < 10) {
				month = "0" + month;
			}
			if (lastmonth < 10) {
				lastmonth = "0" + lastmonth;
			}
			var firstDayOfPreMonth = year + "-" + month + "-" + "01";
			var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem || '00:00:00'}`;
			// var lastDay = new Date(lastyear, lastmonth, 0);
			let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem || '00:00:00'}`;
			this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
			this.dateNowDayActive = false
			this.dateYesterdayActive = false
			this.dateNowMonthActive = false
			this.dateLastMonthActive = true
		},
		handleSizeChange(val) {
			this.pageMo = 1
			this.limitMo = val;
			this.pageList();
		},
		// 点击页码
		handleCurrentChange(val) {
			this.pageMo = val;
			this.pageList();
		},
	}
}
</script>

<style scoped>
.CustomerfillingDig-tab {
	padding-left: 20px;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
	display: flex;
	height: 50px;
	line-height: 50px;
	text-align: center;
	font-size: 16px;
	color: #333;
	vertical-align: top;
}

.CustomerfillingDig-tab-li>div {
	border: 1px solid #CDCDCD;
	border-top: none;
}

.CustomerfillingDig-tab-li>div:first-child {
	border-right: none;
}

.CustomerfillingDig-tab-li:first-child>div {
	border-top: 1px solid #CDCDCD;
}

.CustomerfillingDig-tab-li>div:last-child,
.rechargeType-tab-li>div:last-child {
	border: none;
	color: #FF4D35;
}

.CustomerfillingDig-tab-li-text {
	flex: .8;
	background: rgba(240, 252, 255, 1);
}

.CustomerfillingDig-tab-li-ipt {
	flex: .8;
}

.rechargeType-tab-li-text {
	flex: .35;
}

.rechargeType-tab-li-ipt {
	flex: .7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
	height: 46px;
	width: 100%;

	text-align: center;

	box-sizing: border-box;
	font-size: 16px;
	color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
	outline: none;
	border: none;
	vertical-align: top;
}

.rechargeType-tab-li-ipt input {
	/* border-radius: 8px; */
	/* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
	flex: .3;
}

.CustomerfillingDig-tab-btn {
	text-align: center;
	margin-top: 30px;
}

.DWD-li {
	display: flex;
	height: 35px;
	line-height: 35px;
	box-sizing: border-box;
	border: 1px solid #999;
	font-size: 16px;
	color: #333;
}

.DWD-li>div {
	padding: 0 5px;
	height: 34px;
	overflow: hidden;
	box-sizing: border-box;
}

.DWD-li-title {
	width: 120px;
	text-align: center;
	border-right: 1px solid #999;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-li-text {
	flex: 1;
}

.DWD-li-text input {
	width: 100%;
	height: 35px;
	line-height: 35px;
	border: none;
	outline: none;
}

.DWD-li+.DWD-li {
	border-top: none;
}

.DWD-table {
	display: flex;
}

.DWD-table-left-flex {
	flex: 1;
}

.DWD-table>div>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	text-align: center;
	border-right: 1px solid #999;
	border-bottom: 1px solid #999;
	box-sizing: border-box;
}

.DWD-table>div>div:first-child {
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table-left-title>div {
	width: 101px;
	text-align: center;
	background-color: rgba(0, 163, 255, .1);
}

.DWD-table .DWD-table-left-title>div {
	padding: 0 5px;
	height: 35px;
	line-height: 35px;
	overflow: hidden;
	box-sizing: border-box;
	border-left: 1px solid #999;
	border-bottom: 1px solid #999;
}

.DetailsWater-img {
	margin-top: 30px;
}

.DetailsWater-img-text {
	display: inline-block;
	width: 101px;
	text-align: center;
	vertical-align: top;
}

.car-number-add {
	/* text-transform: uppercase; */
}

.billOperationRecord-table {
	padding: 30px 20px 0;
}

.public_singleMenu .pulic_carNumber {
	margin-top: 6px;
	height: 40px;
	line-height: 40px;
	box-sizing: border-box;
	font-size: 14px;
	display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
	background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
	flex: 1.5;
}

.fontBlue {
	color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
	margin-top: 6px;
	height: 40px;
	line-height: 40px;
	box-sizing: border-box;
	font-size: 14px;
	display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
	height: 45px;
	align-items: center;
}

.billOperationRecord {
	background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
	text-align: center !important;
}

/* 统计 START*/
.imgStatistics {
	width: 40px;
	height: 40px;
}

.payType {
	font-size: 20px;
	/* font-size: 24px; */
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: rgba(102, 102, 102, 1);
	line-height: 26px;
}

.singular {
	font-size: 32px;
	font-family: Microsoft YaHei;
	font-weight: bold;
	color: rgba(51, 51, 51, 1);
	line-height: 30px;
	vertical-align: middle;
	padding-left: 10px;
}

.Amount {
	font-size: 32px;
	font-family: Microsoft YaHei;
	/* font-weight:bold; */
	line-height: 30px;
	vertical-align: middle;
	padding-left: 10px;
}

.pulic_statistics_titlt {
	line-height: 40px;
}

.yqmain {
	/* display: flex; */
}

/* 统计 END*/
</style>
<style>
.el-form-item__label {
	width: 150px !important;
}
</style>
